import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="center" style={{ padding: "20vh 16px" }}>
      <p style={{ fontSize: 64, fontWeight: 800, color: "var(--ink-600)", margin: 0 }}>404</p>
      <h1 style={{ fontSize: 20 }}>This page doesn't exist</h1>
      <Link to="/" className="btn primary" style={{ display: "inline-block", marginTop: 24 }}>Go home</Link>
    </div>
  );
}
